var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { muteContactAsync, unmuteContactAsync } from 'membre/store/actions';
import { dispatch } from 'store/store';
export class MembreContactNotifMuette {
    /**
     * Constructeur de l'objet MembreContactNotifMuette
     * @param row contient les données de l'objet
     */
    constructor(row) {
        if (row) {
            const { idMembreContactNotifMuette, idMembre, idContact } = row;
            this.idMembreContactNotifMuette = idMembreContactNotifMuette;
            this.idMembre = idMembre;
            this.idContact = idContact;
        }
    }
    /**
     * Ajoute un membre à la liste des membres dont on ne veut plus recevoir de notifications
     * @param membre Membre à ajouter
     */
    static add(membre) {
        return __awaiter(this, void 0, void 0, function* () {
            dispatch(muteContactAsync(membre.infoPublic.idMembre));
        });
    }
    /**
     * Supprime un membre de la liste des membres dont on ne veut plus recevoir de notifications
     */
    remove() {
        dispatch(unmuteContactAsync(this.idContact));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlQ29udGFjdE5vdGlmTXVldHRlLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTWVtYnJlQ29udGFjdE5vdGlmTXVldHRlLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQzVFLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFHdkMsTUFBTSxPQUFPLHdCQUF3QjtJQWdCcEM7OztPQUdHO0lBQ0gsWUFBbUIsR0FBdUM7UUFDekQsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsMEJBQTBCLEVBQUUsUUFBUSxFQUFFLFNBQVMsRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUNoRSxJQUFJLENBQUMsMEJBQTBCLEdBQUcsMEJBQTBCLENBQUM7WUFDN0QsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLENBQUM7WUFDekIsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7U0FDM0I7SUFDRixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksTUFBTSxDQUFPLEdBQUcsQ0FBQyxNQUFjOztZQUNyQyxRQUFRLENBQUMsZ0JBQWdCLENBQUMsTUFBTSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDO1FBQ3hELENBQUM7S0FBQTtJQUVEOztPQUVHO0lBQ0ksTUFBTTtRQUNaLFFBQVEsQ0FBQyxrQkFBa0IsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztJQUM5QyxDQUFDO0NBQ0QifQ==